import React, { ReactElement } from 'react'
import { Box, Columns, ColumnProps } from '@lightspeed/design-system-react'

interface FormRowProps {
  children: ReactElement<ColumnProps> | Array<ReactElement<ColumnProps>>
}

export const FormRow: React.FC<FormRowProps> = ({ children }) => {
  return (
    <Box className="vd-mb6">
      <Columns space={0}>{children}</Columns>
    </Box>
  )
}
